import { useTranslation } from 'react-i18next';
import CreatableSelect from '../../../shared/CreatableSelect/CreatableSelect.jsx';

import styles from '../vault.module.css';

export const VendorSelect = ({ vendors = [], value, onChange }) => {
  const { t } = useTranslation('vault');

  return (
    <div className={styles.vendorSelectWrapper}>
      <CreatableSelect
        isMulti={true}
        isClearable={true}
        isSearchable={true}
        placeholder={t('selectVendor')}
        value={value}
        onChange={options => onChange(options || [])}
        options={vendors}
        menuPortalTarget={document.body}
        menuPosition="fixed"
      />
    </div>
  );
};
